/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./geoDetails.vue?vue&type=template&id=3ef7c396&scoped=true"
import script from "./geoDetails.vue?vue&type=script&lang=js"
export * from "./geoDetails.vue?vue&type=script&lang=js"
import style0 from "./geoDetails.vue?vue&type=style&index=0&id=3ef7c396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef7c396",
  null
  
)

export default component.exports